import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { Observable, catchError, of } from "rxjs";
import { AddressInput, UpdateCustomerAddressInput } from "../../inputs";
import { CustomerAddressResponse, AddressResponse, SubmitResponse } from "../../models";
import { HttpService } from "./http.service";
import { otpInput, otpVerifyInput } from "../../inputs/user.input";

@Injectable({
    providedIn: 'root'
})
export class OtpService extends HttpService<
    otpInput |otpVerifyInput,
    CustomerAddressResponse | AddressResponse
> {
    constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
        super(httpClient, apiUrl, apiVersion, 'mobile-otp');
    }

  otpPhoneAddress(addressId: otpInput): Observable<SubmitResponse> {
    return this.create(addressId, `address/send`).pipe(catchError((error) => of(error)));
  }
  otpVerifyPhoneAddress(otpVerify: otpVerifyInput): Observable<SubmitResponse> {
    return this.create(otpVerify, `address/verify`).pipe(catchError((error) => of(error)));
  }

}